import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { ValidatorForm } from "react-material-ui-form-validator";
import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/Add";
import Button from "@material-ui/core/Button";
import MaterialTable, { MTableBodyRow } from "material-table";
import AdminFetchServerData from "../../../provider/AdminFetchServerData";
import store from "../../../redux/store";
import Utils from "../../../provider/Utils";
import UiUtils from "../../../provider/UiUtils";
import AdminMenuWithBreadScrum from "../adminMenu/AdminMenuWithBreadScrum";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import SaveIcon from "@material-ui/icons/Save";
import CloseIcon from "@material-ui/icons/Close";
import { BUSINESS_DOMAIN } from "../../../provider/Enums";

class AdminAccountBilling extends Component {
  header = store.getState().adminHeader.adminHeader;
  breadCrumb = [
    { pageid: "/accountList", uiname: "Accounts List" },
    { pageid: "/viewAccount", uiname: "Account" },
    { pageid: "", uiname: "Billing History" },
  ];
  constructor(props) {
    super(props);
    let accountId = "";
    let businessDomain = null;
    let planType = null;
    if (props.state) {
      accountId = props.state.accountId;
      businessDomain = props.state.businessDomain;
      planType = props.state.planType;
    }
    if (null !== accountId && accountId > 0) {
      this.getAccountBilling(accountId);
    }

    this.state = {
      businessDomain: businessDomain,
      planType: planType,
      initialPage: 0,
      pageSize: 20,
      overagePaymentListInitialPage: 0,
      overagePaymentListPageSize: 20,
      cardListInitialPage: 0,
      cardListPageSize: 20,
      partialamount: "",
      orderPaymentId: "",
      onetimeBonusCredits: 0,
      recurringBonusCredits: 0,
      subscriptionId: "",
      accountId: accountId,
      creditCardList: [],
      customerPaymentList: [],
      overagePaymentList: [],
      subscriptions: [],
      render: false,
      openRefund: false,
      isFullRefund: false,
      isPartialRefund: false,
      openBonusCredits: false,
      isOnetime: false,
      isRecurring: false,
    };
  }

  getAccountBilling(accountId) {
    const postObject = {
      header: {
        ...this.header,
        tid: accountId,
      },
      account: {
        id: accountId,
      },
    };

    AdminFetchServerData.callPostService(
      "/apAccountms/getBilling",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let creditCardList = output.data.creditCardList;
        let businessUseCase = output.data.businessUseCase;
        let customerPaymentList = output.data.customerPaymentList;
        let overagePaymentList = output.data.overagePaymentList;
        let subscriptions = output.data.subscriptions;
        let isPaging = false;
        if (customerPaymentList.length > this.state.pageSize) {
          isPaging = true;
        }

        for (let i = 0; i < customerPaymentList.length; i++) {
          customerPaymentList[i].cycleStartDate = Utils.getUtcToLocal(
            customerPaymentList[i].cycleStartDate
          );
          customerPaymentList[i].cycleEndDate = Utils.getUtcToLocal(
            customerPaymentList[i].cycleEndDate
          );
          customerPaymentList[i].orderDate = Utils.getUtcToLocal(
            customerPaymentList[i].orderDate
          );
        }

        let isOveragePaymentListPaging = false;
        if (
          overagePaymentList.length > this.state.overagesPaymentListPageSize
        ) {
          isOveragePaymentListPaging = true;
        }
        for (let i = 0; i < overagePaymentList.length; i++) {
          overagePaymentList[i].cycleStartDate = Utils.getUtcToLocal(
            overagePaymentList[i].cycleStartDate
          );
          overagePaymentList[i].cycleEndDate = Utils.getUtcToLocal(
            overagePaymentList[i].cycleEndDate
          );
          overagePaymentList[i].orderDate = Utils.getUtcToLocal(
            overagePaymentList[i].orderDate
          );
        }

        let iscardListPaging = false;
        if (creditCardList.length > this.state.cardListPageSize) {
          iscardListPaging = true;
        }

        for (let i = 0; i < creditCardList.length; i++) {
          creditCardList[i].address = Utils.getAddressAsText(
            creditCardList[i].billingAddress
          );
        }

        for (let i = 0; i < subscriptions.length; i++) {
          subscriptions[i].subscriptionStartdate = Utils.getUtcToLocal(
            subscriptions[i].subscriptionStartdate
          );
          subscriptions[i].subscriptionEnddate = Utils.getUtcToLocal(
            subscriptions[i].subscriptionEnddate
          );
          subscriptions[i].orderDate = Utils.getUtcToLocal(
            subscriptions[i].orderDate
          );
          subscriptions[i].bonusCreditDate = Utils.getUtcToLocal(
            subscriptions[i].bonusCreditDate
          );
        }
        this.setState({
          render: true,
          open: false,
          openBonusCredits: false,
          // action: "view",
          isPaging: isPaging,
          isOveragePaymentListPaging: isOveragePaymentListPaging,
          iscardListPaging: iscardListPaging,
          creditCardList: creditCardList,
          customerPaymentList: customerPaymentList,
          overagePaymentList: overagePaymentList,
          businessUseCase: businessUseCase,
          subscriptions: subscriptions,
        });
      }
    });
  }
  viewCancel() {
    this.props.navigate("/viewAccount", {
      state: {
        action: "view",
        accountId: this.state.accountId,
      },
    });
  }
  handleRefundClose() {
    this.setState({
      openRefund: false,
      isFullRefund: false,
      isPartialRefund: false,
    });
  }
  handleRefundOpen(e, data) {
    this.setState({
      openRefund: true,
      orderPaymentId: data.id,
    });
  }
  handlePartialamountChange(e) {
    this.setState({
      partialamount: e.target.value,
    });
  }
  refundInBackend() {
    const postObject = {
      header: {
        ...this.header,
        tid: this.state.accountId,
      },
      isFullRefund: this.state.isFullRefund,
      refundAmount: this.state.partialamount,
      orderPayment: { id: this.state.orderPaymentId },
    };

    AdminFetchServerData.callPostService("/paymentms/refund", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          this.getAccountBilling(this.state.accountId);
          this.setState({
            openRefund: false,
            isFullRefund: false,
            isPartialRefund: false,
          });
        }
      }
    );
  }

  handleFullRefundChange(e) {
    this.setState({
      isFullRefund: e.target.checked,
      isPartialRefund: false,
      partialamount: "",
    });
  }
  handlePartialRefundChange(e) {
    this.setState({
      isPartialRefund: e.target.checked,
      isFullRefund: false,
    });
  }

  handleIsRecurringCheckboxChange(e) {
    this.setState({
      isRecurring: e.target.checked,
      isOnetime: false,
      onetimeBonusCredits: 0,
    });
  }

  handleRecurringBonusCreditChange(e) {
    this.setState({
      recurringBonusCredits: e.target.value,
    });
  }
  handleIsOnetimeCheckboxChange(e) {
    this.setState({
      isOnetime: e.target.checked,
      isRecurring: false,
      recurringBonusCredits: 0,
    });
  }
  handleOnetimeBonusCreditsChange(e) {
    this.setState({
      onetimeBonusCredits: e.target.value,
    });
  }
  handleBonusCreditsOpen(e, data) {
    this.setState({
      openBonusCredits: true,
      subscriptionId: data.id,
    });
  }
  handleBonusCreditsClose() {
    this.setState({
      openBonusCredits: false,
    });
  }

  updateBonusCreditsToBackend(e, data) {
    const postObject = {
      header: {
        ...this.header,
        tid: this.state.accountId,
      },
      onetimeBonusCredits: this.state.onetimeBonusCredits,
      subscription: {
        id: this.state.subscriptionId,
        recurringBonusCredits: this.state.recurringBonusCredits,
      },
    };

    AdminFetchServerData.callPostService(
      "/paymentms/updateBonusCredits",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        this.getAccountBilling(this.state.accountId);
      }
    });
  }

  editOnetimeBonusCredits(e, data) {
    this.setState({
      openBonusCredits: true,
      subscriptionId: data.id,
      isOnetime: true,
      isRecurring: false,
      onetimeBonusCredits: data.onetimeBonusCredits,
      recurringBonusCredits: 0,
    });
  }
  editRecurringBonusCredits(e, data) {
    this.setState({
      openBonusCredits: true,
      subscriptionId: data.id,
      isOnetime: false,
      isRecurring: true,
      recurringBonusCredits: data.recurringBonusCredits,
      onetimeBonusCredits: 0,
    });
  }

  toAssignPlanDetails(eventId) {
    this.props.navigate("/accountAssignPlan", {
      state: {
        action: "view",
        eventId: eventId,
        accountId: this.state.accountId,
        businessDomain: this.state.businessDomain,
      },
    });
  }

  render() {
    if (this.state.render === false) {
      return <div />;
    } else {
      return (
        <>
          <AdminMenuWithBreadScrum
            breadCrumb={this.breadCrumb}
            navigate={this.props.navigate}
            name="Billing History"
            backCallback={this.viewCancel.bind(this)}
          />
          <div className="mt-4 billingHistory" style={{ maxWidth: "100%" }}>
            <MaterialTable
              title="Credit Card List"
              icons={UiUtils.getMaterialTableIcons()}
              // onRowClick={(event, rowData) => {
              //   this.toEditCreditCardDetails(event, rowData);
              //   event.stopPropagation();
              // }}
              localization={{
                body: {
                  emptyDataSourceMessage: (
                    <h5 className="dataNotAvailable">No data found.</h5>
                  ),
                },
              }}
              columns={[
                {
                  title: <span style={{ paddingLeft: "14px" }}>#</span>,
                  render: (rowData) => (
                    <span style={{ paddingLeft: "14px" }}>
                      {rowData.tableData.id + 1}
                    </span>
                  ),
                  width: "5%",
                  align: "left",
                  cellStyle: {
                    width: "6%",
                  },
                },
                {
                  title: "Name on Card",
                  field: "fullName",
                  cellStyle: {
                    width: "22%",
                  },
                },
                {
                  title: "Card Type",
                  field: "type",
                  cellStyle: {
                    width: "22%",
                  },
                },
                {
                  title: "Card Number",
                  field: "number",
                  cellStyle: {
                    width: "22%",
                  },
                },
                {
                  title: "Card Expiration Date",
                  render: (rowData) => `${rowData.month}/${rowData.year}`,
                  width: "5%",
                  align: "left",
                  cellStyle: {
                    width: "25%",
                  },
                },
              ]}
              data={this.state.creditCardList}
              options={{
                emptyRowsWhenPaging: false,
                sorting: true,
                search: true,
                actionsColumnIndex: -1,
                initialPage: this.state.cardListInitialPage,
                pageSize: this.state.cardListPageSize,
                pageSizeOptions: Utils.materialTablePageSize(),
                paging: this.state.iscardListPaging,
                headerStyle: {
                  backgroundColor: "#37517e",
                  fontWeight: "bold",
                  color: "#ffff",
                  align: "left",
                },
              }}
              detailPanel={(rowData) => (
                <>
                  <div
                    className="row d-flex justify-content-end"
                    style={{ padding: "10px" }}
                  >
                    <table class="table treeTable">
                      <thead>
                        <tr style={{ textTransform: "capitalize" }}>
                          {/* <th scope="col"></th> */}
                          {/* <th scope="col">#</th> */}
                          <th scope="col"> Type</th>
                          <th scope="col"> Amount</th>
                          <th scope="col"> Billed Date</th>
                          <th scope="col"> Start Date</th>
                          <th scope="col">End Date</th>
                          <th scope="col"> Transaction ID</th>
                          <th scope="col">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rowData.paymentList?.map((value, index) => (
                          <tr>
                            {/* <th scope="row"></th> */}
                            {/* <td scope="row">{index + 1}</td> */}
                            <td>{value.subscriptionType}</td>
                            <td>{`${value.currencySymbol
                              }${Utils.formatWithCommas(value.paidAmount)}`}</td>
                            <td>{Utils.getUtcToLocal(value.orderDate)}</td>
                            <td>
                              {Utils.getUtcToLocal(value.subscriptionStartdate)}
                            </td>
                            <td>
                              {Utils.getUtcToLocal(value.subscriptionEnddate)}
                            </td>
                            <td>{value.transactionId}</td>
                            <td>{value.subscriptionStatus}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
              onChangePage={(page, pageSize) => {
                this.handleMaterialTablePageChange(page, pageSize);
              }}
            />
            {this.state.subscriptions.length > 1 ? (
              <div className="billingHistory mt-4" style={{ width: "100%" }}>
                <MaterialTable
                  title="Plan and Subscription"
                  icons={UiUtils.getMaterialTableIcons()}
                  localization={{
                    body: {
                      emptyDataSourceMessage: (
                        <h5 className="dataNotAvailable">No data found.</h5>
                      ),
                    },
                  }}
                  columns={[
                    {
                      title: <span style={{ paddingLeft: "14px" }}>#</span>,
                      render: (rowData) => (
                        <span style={{ paddingLeft: "14px" }}>
                          {rowData.tableData.id + 1}
                        </span>
                      ),
                      width: "5%",
                      align: "left",
                      cellStyle: {
                        width: "6%",
                      },
                    },
                    {
                      title: "Event Name",
                      field: "eventName",
                      cellStyle: {
                        width: "16%",
                      },
                    },
                    {
                      title: "Type",
                      field: "subscriptionType",
                      render: (rowData) => {
                        if (rowData?.recurringBonusCredits > 0) {
                          return `${rowData.subscriptionType} + Bonus (${rowData.recurringBonusCredits})`;
                        }

                        if (rowData?.onetimeBonusCredits > 0) {
                          return `${rowData.subscriptionType} + Bonus (${rowData.onetimeBonusCredits})`;
                        }
                        return rowData?.subscriptionType || "-";
                      },
                      cellStyle: {
                        width: "12%",
                      },
                    },
                    {
                      title: "Amount $",
                      // field: "totalAmount",
                      render: (rowData) =>
                        `${rowData.currencySymbol !== null
                          ? rowData.customerPlan?.currencySymbol
                          : ""
                        }${rowData.customerPlan?.price > 0
                          ? Utils.formatWithCommas(
                            rowData.customerPlan?.price
                          )
                          : "NA"
                        }`,
                      customSort: (a, b) => {
                        return (
                          parseFloat(a.customerPlan?.price) -
                          parseFloat(b.customerPlan?.price)
                        );
                      },
                      cellStyle: {
                        width: "10%",
                      },
                    },
                    {
                      title: "Text Credits",
                      field: "smsCredits",
                      render: (rowData) => rowData.smsCredits,
                      cellStyle: {
                        width: "12%",
                      },
                    },
                    {
                      title: "Start Date",
                      field: "subscriptionStartdate",
                      cellStyle: {
                        width: "10%",
                      },
                    },
                    {
                      title: "End Date",
                      field: "subscriptionEnddate",
                      cellStyle: {
                        width: "10%",
                      },
                    },

                    {
                      title: "Status",
                      field: "subscriptionStatus",
                      cellStyle: {
                        width: "10%",
                      },
                    },
                    {
                      title: "Action",
                      render: (rowData) => (
                        <>
                          <div className="row d-flex">
                            <Button
                              className="mb-1"
                              id="sendQuicktextButton"
                              variant="contained"
                              style={{ textTransform: "initial", width: "160px" }}
                              type="button"
                              onClick={this.toAssignPlanDetails.bind(this, rowData?.eventId)}
                            >
                              Assign a plan
                            </Button>
                            {(
                              (rowData?.onetimeBonusCredits === 0 &&
                                rowData?.recurringBonusCredits === 0) ||
                              (rowData?.onetimeBonusCredits === null &&
                                rowData?.recurringBonusCredits === null)
                            ) && (
                                <Button
                                  key={rowData.id}
                                  id="ptsHollowButton"
                                  variant="contained"
                                  style={{ textTransform: "initial", width: "160px" }}
                                  type="button"
                                  startIcon={<AddIcon />}
                                  onClick={(event) =>
                                    this.handleBonusCreditsOpen(event, rowData)
                                  }
                                >
                                  Add bonus credits
                                </Button>
                              )}

                            {
                              (rowData?.onetimeBonusCredits !== null &&
                                rowData?.onetimeBonusCredits > 0) && (
                                <Button
                                  key={rowData.id}
                                  id="ptsHollowButton"
                                  variant="contained"
                                  style={{ textTransform: "initial", width: "160px" }}
                                  type="button"
                                  startIcon={<EditIcon />}
                                  onClick={(event) =>
                                    this.editOnetimeBonusCredits(event, rowData)
                                  }
                                >
                                  Edit bonus credits
                                </Button>
                              )
                            }

                          </div>
                        </>
                      ),
                      cellStyle: {
                        width: "16%",
                      },
                    },
                  ]}
                  data={this.state.subscriptions}
                  options={{
                    emptyRowsWhenPaging: false,
                    sorting: true,
                    search: true,
                    actionsColumnIndex: -1,
                    initialPage: this.state.initialPage,
                    pageSize: this.state.pageSize,
                    pageSizeOptions: Utils.materialTablePageSize(),
                    paging: this.state.subscriptions?.length > 10 ? true : false,
                    headerStyle: {
                      backgroundColor: "#37517e",
                      fontWeight: "bold",
                      color: "#ffff",
                      align: "left",
                    },
                  }}
                />
              </div>
            ) : (
              <div className="row mt-3" style={{ padding: "0em 0em" }}>
                <div className="col-md-12">
                  <div className="card">
                    <div
                      className="card-header d-flex align-items-center justify-content-between"
                      id="assetCardHeader"
                    >
                      <div className="col-sm-6">
                        <h6 className="mb-0" id="headerLabel">
                          <b>Plan and Subscription</b>
                        </h6>
                      </div>
                      <div className="col-sm-6 text-end">
                        <Button
                          id="sendQuicktextButton"
                          variant="contained"
                          style={{ textTransform: "initial" }}
                          type="button"
                          onClick={this.toAssignPlanDetails.bind(this, null)}
                        >
                          Assign a plan
                        </Button>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        {this.state.subscriptions.map((value, index) => {
                          const isEndDatePassed =
                            value?.subscriptionEnddate &&
                            new Date(value.subscriptionEnddate) < new Date();
                          return (
                            <React.Fragment key={index}>
                              <>
                                <div className="col-md-3">
                                  <div
                                    className="row d-flex"
                                    style={{
                                      height: "100%",
                                    }}
                                  >
                                    <div className="col-md-12 mt-4">
                                      <div
                                        className="row d-flex"
                                        style={{
                                          height: "100%",
                                        }}
                                      >
                                        <div className="col-md-12">
                                          <div
                                            className="box"
                                            data-aos="zoom-in"
                                            data-aos-delay={100}
                                            style={{
                                              padding: "0em",
                                              position: "relative",
                                              height: "100%",
                                            }}
                                            id="regPlanBox"
                                          >
                                            <div
                                              className="regplan-inner plan_card plan_card_bottom d-flex flex-column"
                                              style={{
                                                height: "100%",
                                              }}
                                            >
                                              <div
                                                className="entry-title plan_card"
                                                style={{
                                                  background:
                                                    value?.customerPlan
                                                      ?.colorSecondary,
                                                }}
                                              >
                                                <h3
                                                  className="plan_card"
                                                  style={{
                                                    padding: "7px",
                                                    color: "#fff",
                                                    background:
                                                      value?.customerPlan
                                                        ?.colorPrimary,
                                                  }}
                                                >
                                                  {value?.customerPlan?.name}
                                                </h3>
                                                <div
                                                  className="price"
                                                  style={{
                                                    background:
                                                      value?.customerPlan
                                                        ?.colorPrimary,
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      left: "20px",
                                                    }}
                                                  >
                                                    {`$${Utils.formatWithCommas(
                                                      value?.customerPlan?.price
                                                    )}`}
                                                  </span>
                                                </div>
                                              </div>
                                              <div className="entry-content flex-grow-1 d-flex flex-column">
                                                <ul className="flex-grow-1 pb-4">
                                                  {value?.customerPlan?.planItems.map(
                                                    (item, i) => (
                                                      <li
                                                        key={i}
                                                        style={{
                                                          padding: "0.2em",
                                                          fontWeight:
                                                            item?.isFontBold &&
                                                            "600",
                                                          fontStyle:
                                                            item?.isFontItalic &&
                                                            "italic",
                                                        }}
                                                      >
                                                        {item.name}
                                                      </li>
                                                    )
                                                  )}
                                                </ul>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-7 align-self-center">
                                  {this.state.businessDomain?.name === BUSINESS_DOMAIN.dpText ?
                                    (
                                      <>
                                        <div className="row">
                                          <label
                                            className="col-sm-4 col-form-label fw-bold"
                                            htmlFor="basic-default-name"
                                            id="assetFormLabel"
                                          >
                                            Current Cycle Start Date
                                          </label>
                                          <div className="col-sm-8" id="OrganizationCol">
                                            <span>{value.subscriptionStartdate}</span>
                                          </div>
                                        </div>
                                        <div className="row">
                                          <label
                                            className="col-sm-4 col-form-label fw-bold"
                                            htmlFor="basic-default-name"
                                            id="assetFormLabel"
                                          >
                                            Current Cycle End Date
                                          </label>
                                          <div className="col-sm-8" id="OrganizationCol">
                                            <span>{value.subscriptionEnddate}</span>
                                          </div>
                                        </div>
                                        <div className="row">
                                          <label
                                            className="col-sm-4 col-form-label fw-bold"
                                            htmlFor="basic-default-name"
                                            id="assetFormLabel"
                                          >
                                            Status
                                          </label>
                                          <div className="col-sm-8" id="OrganizationCol">
                                            <span>{value.subscriptionStatus}</span>
                                          </div>
                                        </div>
                                      </>
                                    )
                                    :
                                    (
                                      <>
                                        <div className="row">
                                          <label
                                            className="col-sm-3 col-form-label fw-bold"
                                            htmlFor="basic-default-name"
                                            id="assetFormLabel"
                                          >
                                            Start Date
                                          </label>
                                          <div className="col-sm-9" id="OrganizationCol">
                                            <span>{value.subscriptionStartdate}</span>
                                          </div>
                                        </div>
                                        <div className="row">
                                          <label
                                            className="col-sm-3 col-form-label fw-bold"
                                            htmlFor="basic-default-name"
                                            id="assetFormLabel"
                                          >
                                            End Date
                                          </label>
                                          <div className="col-sm-9" id="OrganizationCol">
                                            <span>{value.subscriptionEnddate}</span>
                                          </div>
                                        </div>
                                        <div className="row">
                                          <label
                                            className="col-sm-3 col-form-label fw-bold"
                                            htmlFor="basic-default-name"
                                            id="assetFormLabel"
                                          >
                                            Status
                                          </label>
                                          <div className="col-sm-9" id="OrganizationCol">
                                            <span>{value.subscriptionStatus}</span>
                                          </div>
                                        </div>
                                      </>
                                    )}

                                  {(value?.onetimeBonusCredits > 0 &&
                                    value?.onetimeBonusCredits !== null) && (
                                      <div className="row">
                                        <label
                                          className="col-sm-3 col-form-label fw-bold pe-0"
                                          htmlFor="basic-default-name"
                                          id="assetFormLabel"
                                        >
                                          Onetime bonus credits
                                        </label>
                                        <div
                                          className="col-sm-1 pe-0"
                                          id="OrganizationCol"
                                        >
                                          <span>{value.onetimeBonusCredits}</span>
                                        </div>
                                        <div
                                          className="col-sm-8"
                                          id="OrganizationCol"
                                        >
                                          <Button
                                            variant="contained"
                                            size="small"
                                            style={{
                                              background: "#d3d8de",
                                              color: "#353538",
                                              marginRight: "1rem",
                                              float: "left",
                                              padding: "2px 10px",
                                              textTransform: "capitalize",
                                            }}
                                            startIcon={<EditIcon />}
                                            onClick={(event) =>
                                              this.editOnetimeBonusCredits(event, value)
                                            }
                                          >
                                            Edit
                                          </Button>
                                        </div>
                                      </div>
                                    )
                                  }
                                  {(value?.recurringBonusCredits > 0 &&
                                    value?.recurringBonusCredits !== null) && (
                                      <div className="row">
                                        <label
                                          className="col-sm-3 col-form-label fw-bold pe-0"
                                          htmlFor="basic-default-name"
                                          id="assetFormLabel"
                                        >
                                          Recurring bonus credits
                                        </label>
                                        <div
                                          className="col-sm-1 pe-0"
                                          id="OrganizationCol"
                                        >
                                          <span>{value.recurringBonusCredits}</span>
                                        </div>
                                        <div
                                          className="col-sm-8"
                                          id="OrganizationCol"
                                        >
                                          <Button
                                            variant="contained"
                                            size="small"
                                            style={{
                                              background: "#d3d8de",
                                              color: "#353538",
                                              marginRight: "1rem",
                                              float: "left",
                                              padding: "2px 10px",
                                              textTransform: "capitalize",
                                            }}
                                            startIcon={<EditIcon />}
                                            onClick={(event) =>
                                              this.editRecurringBonusCredits(event, value)
                                            }
                                          >
                                            Edit
                                          </Button>
                                        </div>
                                      </div>
                                    )
                                  }
                                  {(value?.bonusCreditDate && value?.bonusCreditDate !== null) && (
                                    <div className="row">
                                      <label
                                        className="col-sm-3 col-form-label fw-bold pe-0"
                                        htmlFor="basic-default-name"
                                        id="assetFormLabel"
                                      >
                                        Last Bonus credited on
                                      </label>
                                      <div
                                        className="col-sm-9"
                                        id="OrganizationCol"
                                      >
                                        <span>{value?.bonusCreditDate}</span>
                                      </div>

                                    </div>
                                  )
                                  }

                                  {isEndDatePassed && (
                                    (value?.onetimeBonusCredits === 0 &&
                                      value?.recurringBonusCredits === 0) ||
                                    (value?.onetimeBonusCredits === null &&
                                      value?.recurringBonusCredits === null)
                                  ) &&
                                    < div className="row mt-2">
                                      <label
                                        className="col-sm-3 col-form-label fw-bold"
                                        htmlFor="basic-default-name"
                                        id="assetFormLabel"
                                      ></label>
                                      <div className="col-sm-9" id="OrganizationCol">
                                        <Button
                                          id="ptsHollowButton"
                                          variant="contained"
                                          style={{ textTransform: "initial" }}
                                          type="button"
                                          onClick={(event) =>
                                            this.handleBonusCreditsOpen(event, value)
                                          }
                                        >
                                          Add bonus credits
                                        </Button>
                                      </div>
                                    </div>
                                  }

                                  {isEndDatePassed && (
                                    <div className="row mt-2">
                                      <label
                                        className="col-sm-3 col-form-label fw-bold pe-0"
                                        htmlFor="basic-default-name"
                                        id="assetFormLabel"
                                      >
                                      </label>
                                      <div
                                        className="col-sm-9"
                                        id="OrganizationCol"
                                      >
                                        <span>{value.bonusCreditDate && `One time/Recurring ${value?.onetimeBonusCredits > 0 ? value?.onetimeBonusCredits : ""} ${value?.recurringBonusCredits > 0 ? value?.recurringBonusCredits : ""} bonus texts credited on ${value.bonusCreditDate}.`}</span>
                                      </div>

                                    </div>
                                  )}
                                </div >
                              </>
                            </React.Fragment>
                          )
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {this.state.customerPaymentList.length > 0 && (
              <div className="billingHistory mt-4" style={{ width: "100%" }}>
                <>
                  <MaterialTable
                    title={Utils.equalsIgnoreCase(this.state.planType?.type, "Onetime") ? "Per Event Charges" : "Subscription Charges"}
                    icons={UiUtils.getMaterialTableIcons()}
                    localization={{
                      body: {
                        emptyDataSourceMessage: (
                          <h5 className="dataNotAvailable">No data found.</h5>
                        ),
                      },
                    }}
                    columns={[
                      {
                        title: <span style={{ paddingLeft: "14px" }}>#</span>,
                        render: (rowData) => (
                          <span style={{ paddingLeft: "14px" }}>
                            {rowData.tableData.id + 1}
                          </span>
                        ),
                        width: "5%",
                        align: "left",
                        cellStyle: {
                          width: "6%",
                        },
                      },
                      !Utils.equalsIgnoreCase(this.state.planType?.type, "Onetime") && {
                        title: "Type",
                        field: "subscriptionType",
                        render: (rowData) => {
                          if (rowData.isOverages) {
                            return "Overages";
                          }

                          if (rowData.subscriptionType && rowData.bonusCredits > 0) {
                            return `${rowData.subscriptionType} + Bonus (${rowData.bonusCredits})`;
                          }

                          return rowData.subscriptionType || "";
                        },
                        cellStyle: {
                          width: "15%",
                        },
                      },
                      this.state.businessDomain?.name === BUSINESS_DOMAIN.eventText &&
                      Utils.equalsIgnoreCase(this.state.planType?.type, "Onetime") && {
                        title: "Event name",
                        field: "eventName",
                        cellStyle: {
                          width: "15%",
                        },
                      },
                      {
                        title: "Amount $",
                        render: (rowData) =>
                          `${rowData.currencySymbol !== null
                            ? rowData.currencySymbol
                            : ""
                          }${rowData.isOverages
                            ? rowData.overageCharges
                            : rowData.paidAmount
                          }`,
                        customSort: (a, b) => {
                          return (
                            parseFloat(a.paidAmount) - parseFloat(b.paidAmount)
                          );
                        },
                        cellStyle: {
                          width: "14%",
                        },
                      },
                      {
                        title: "Text Usage",
                        render: (rowData) => {
                          const used = rowData.consumedCredits ?? 0;
                          const avail = rowData.availableCredits ?? 0;
                          return (
                            <div
                              style={{
                                display: "flex",
                                width: "100%",
                              }}
                            >
                              <span>{`${used} / ${avail}`}</span>
                            </div>
                          );
                        },
                        customSort: (a, b) => {
                          const usedA = a.consumedCredits ?? 0;
                          const availA = a.availableCredits ?? 1; // prevent divide by zero
                          const percentA = usedA / availA;

                          const usedB = b.consumedCredits ?? 0;
                          const availB = b.availableCredits ?? 1;
                          const percentB = usedB / availB;

                          return percentA - percentB;
                        },
                        cellStyle: { width: "16%" },
                      },
                      // {
                      //   title: "Overages $",
                      //   render: (rowData) =>
                      //     rowData.overageCharges > 0 ? (
                      //       rowData.overageDescription ? (
                      //         <Tooltip
                      //           title={rowData.overageDescription}
                      //           arrow
                      //           classes={{
                      //             popper: "custom-tooltip",
                      //           }}
                      //         >
                      //           <span>
                      //             {rowData.currencySymbol ?? ""}
                      //             {rowData.overageCharges}
                      //           </span>
                      //         </Tooltip>
                      //       ) : (
                      //         <span>
                      //           {rowData.currencySymbol ?? ""}
                      //           {rowData.overageCharges}
                      //         </span>
                      //       )
                      //     ) : (
                      //       "NA"
                      //     ),
                      //   customSort: (a, b) =>
                      //     parseFloat(a.overageCharges) -
                      //     parseFloat(b.overageCharges),
                      //   cellStyle: { width: "15%" },
                      // },
                      {
                        title: "Start Date",
                        field: "cycleStartDate",
                        cellStyle: {
                          width: "15%",
                        },
                      },
                      {
                        title: "End Date",
                        field: "cycleEndDate",
                        cellStyle: {
                          width: "12%",
                        },
                      },
                      {
                        title: "Transaction ID",
                        field: "transactionId",
                        cellStyle: {
                          width: "15%",
                        },
                      },
                      {
                        title: "Payment",
                        field: "paymentStatus",
                        cellStyle: {
                          width: "10%",
                        },
                      },
                      {
                        title: "Action",
                        render: (rowData) => (
                          <>
                            {rowData.isRefunded === false && (
                              <Button
                                id="ptsHollowButton"
                                variant="contained"
                                style={{ textTransform: "initial" }}
                                type="button"
                                onClick={(event) =>
                                  this.handleRefundOpen(event, rowData)
                                }
                              >
                                Refund
                              </Button>
                            )}

                            {rowData.refundAmount !== null &&
                              rowData.refundAmount > 0 && (
                                <span>{`Refunded $${rowData.refundAmount}`}</span>
                              )}
                          </>
                        ),
                        cellStyle: {
                          width: "8%",
                        },
                      },
                    ].filter(Boolean)}
                    data={this.state.customerPaymentList}
                    options={{
                      emptyRowsWhenPaging: false,
                      sorting: true,
                      search: true,
                      actionsColumnIndex: -1,
                      initialPage: this.state.initialPage,
                      pageSize: this.state.pageSize,
                      pageSizeOptions: Utils.materialTablePageSize(),
                      paging: this.state.isPaging,
                      headerStyle: {
                        backgroundColor: "#37517e",
                        fontWeight: "bold",
                        color: "#ffff",
                        align: "left",
                      },
                    }}
                    components={{
                      Row: React.forwardRef((props, ref) => {
                        const text = props.data?.overageDescription || "";

                        if (!text) {
                          return <MTableBodyRow ref={ref} {...props} />;
                        }
                        return (
                          <Tooltip
                            title={text}
                            arrow
                            followCursor
                            classes={{ popper: "custom-tooltip" }}
                          >
                            <MTableBodyRow ref={ref} {...props} />
                          </Tooltip>
                        );
                      }),
                    }}
                  />
                </>
              </div>
            )}
            {this.state.overagePaymentList.length > 0 && (
              <div className="billingHistory mt-4" style={{ width: "100%" }}>
                <>
                  <MaterialTable
                    title="Overages Charges"
                    icons={UiUtils.getMaterialTableIcons()}
                    localization={{
                      body: {
                        emptyDataSourceMessage: (
                          <h5 className="dataNotAvailable">No data found.</h5>
                        ),
                      },
                    }}
                    columns={[
                      {
                        title: "#",
                        render: (rowData) => rowData.tableData.id + 1,
                        width: "5%",
                        align: "left",
                        cellStyle: {
                          width: "6%",
                        },
                      },
                      {
                        title: "Plan",
                        field: "subscriptionType",
                        cellStyle: {
                          width: "15%",
                        },
                      },
                      {
                        title: "Amount",
                        // field: "totalAmount",
                        render: (rowData) =>
                          `${rowData.currencySymbol !== null
                            ? rowData.currencySymbol
                            : ""
                          }${rowData.paidAmount}`,
                        cellStyle: {
                          width: "15%",
                        },
                      },
                      {
                        title: "Billed Date",
                        field: "orderDate",
                        cellStyle: {
                          width: "15%",
                        },
                      },
                      {
                        title: "Start Date",
                        field: "cycleStartDate",
                        cellStyle: {
                          width: "15%",
                        },
                      },
                      {
                        title: "End Date",
                        field: "cycleEndDate",
                        cellStyle: {
                          width: "15%",
                        },
                      },
                      {
                        title: "Status",
                        field: "subscriptionStatus",
                        cellStyle: {
                          width: "15%",
                        },
                      },
                    ]}
                    data={this.state.overagePaymentList}
                    options={{
                      emptyRowsWhenPaging: false,
                      sorting: true,
                      search: true,
                      actionsColumnIndex: -1,
                      initialPage: this.state.overagePaymentListInitialPage,
                      pageSize: this.state.overagePaymentListPageSize,
                      pageSizeOptions: Utils.materialTablePageSize(),
                      paging: this.state.isOveragePaymentListPaging,
                      headerStyle: {
                        backgroundColor: "#37517e",
                        fontWeight: "bold",
                        color: "#ffff",
                        align: "left",
                      },
                    }}
                  />
                </>
              </div>
            )}
          </div >
          <Dialog
            open={this.state.openRefund}
            onClose={this.handleRefundClose.bind(this)}
            onHide={this.close}
            style={{ padding: "1em" }}
          >
            <ValidatorForm
              className="text-start"
              ref="form"
              onSubmit={this.refundInBackend.bind(this)}
            >
              <DialogContent style={{ width: "400px" }}>
                <p
                  style={{
                    fontSize: "17px",
                    lineHeight: "1.3em",
                    fontWeight: "600",
                  }}
                >
                  Please refund:
                </p>
                <div className="row justify-content-start">
                  <div className="col-sm-12 d-flex">
                    <span className="me-2" style={{ marginTop: "1px" }}>
                      <input
                        type="checkbox"
                        id="fullrefund-checkbox"
                        value={this.state.isFullRefund}
                        onChange={(e) => this.handleFullRefundChange(e)}
                        checked={this.state.isFullRefund}
                      />
                    </span>

                    <label
                      className="form-label"
                      htmlFor="fullrefund-checkbox"
                      style={{ cursor: "pointer" }}
                    >
                      Full amount
                    </label>
                  </div>
                </div>
                <div
                  className="row justify-content-start mt-2"
                  style={{ height: "35px" }}
                >
                  <div className="col-sm-5 d-flex align-self-center">
                    <span className="me-2" style={{ marginTop: "1px" }}>
                      <input
                        type="checkbox"
                        id="partialrefund-checkbox"
                        value={this.state.isPartialRefund}
                        onChange={(e) => this.handlePartialRefundChange(e)}
                        checked={this.state.isPartialRefund}
                      />
                    </span>
                    <label
                      className="form-label"
                      htmlFor="partialrefund-checkbox"
                      style={{ cursor: "pointer" }}
                    >
                      Partial amount
                    </label>
                  </div>
                  {this.state.isPartialRefund && (
                    <div className="col-sm-5 d-flex">
                      <span
                        className="input-group-addon align-content-center inputFundraising"
                        style={{ width: "40px" }}
                      >
                        $
                      </span>
                      <input
                        type="number"
                        autoComplete="off"
                        id="multiStepsFirstName"
                        name="multiStepsFirstName"
                        className="form-control"
                        style={{
                          borderRadius: " 0rem 0.375rem 0.375rem 0rem",
                          padding: "5px 10px",
                        }}
                        value={this.state.partialamount}
                        onChange={this.handlePartialamountChange.bind(this)}
                        onFocus={(event) => {
                          event.target.select();
                        }}
                      />
                    </div>
                  )}
                </div>
              </DialogContent>
              <DialogActions
                className="justify-content-center"
                style={{
                  padding: "1.5em",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              >
                <Button
                  variant="contained"
                  size="large"
                  type="submit"
                  style={{
                    background: "#0B6F9D",
                    color: "#fff",
                    marginRight: "1rem",
                    padding: "2px 10px",
                    textTransform: "capitalize",
                  }}
                  startIcon={<SaveIcon />}
                >
                  Refund
                </Button>
                <Button
                  variant="contained"
                  size="large"
                  style={{
                    background: "#717373",
                    color: "#fff",
                    marginRight: "1rem",
                    padding: "2px 10px",
                    textTransform: "capitalize",
                  }}
                  startIcon={<CloseIcon />}
                  onClick={this.handleRefundClose.bind(this)}
                >
                  Cancel
                </Button>
              </DialogActions>
            </ValidatorForm>
          </Dialog>
          <Dialog
            open={this.state.openBonusCredits}
            onClose={this.handleBonusCreditsClose.bind(this)}
            onHide={this.close}
            style={{ padding: "1em" }}
          >
            <ValidatorForm
              className="text-start"
              ref="form"
              onSubmit={this.updateBonusCreditsToBackend.bind(this)}
            >
              <DialogContent style={{ width: "400px" }}>
                <p
                  style={{
                    fontSize: "17px",
                    lineHeight: "1.3em",
                    fontWeight: "600",
                  }}
                >
                  Give bonus credits:
                </p>
                {this.state.businessDomain?.name !== BUSINESS_DOMAIN.eventText ?
                  <>
                    <div
                      className="row justify-content-center"
                      style={{ height: "38px" }}
                    >
                      <div className="col-sm-4 d-flex align-self-center">
                        <span className="me-2" style={{ marginTop: "1px" }}>
                          <input
                            type="checkbox"
                            id="ontimeBonusCredits-checkbox"
                            value={this.state.isOnetime}
                            onChange={(e) => this.handleIsOnetimeCheckboxChange(e)}
                            checked={this.state.isOnetime}
                          />
                        </span>

                        <label
                          className="form-label"
                          htmlFor="ontimeBonusCredits-checkbox"
                          style={{ cursor: "pointer" }}
                        >
                          Onetime
                        </label>
                      </div>
                      <div className="col-sm-3 d-flex ps-0 align-self-center">
                        {this.state.isOnetime && (
                          <>
                            <input
                              type="number"
                              autoComplete="off"
                              id="multiStepsFirstName"
                              name="multiStepsFirstName"
                              className="form-control"
                              style={{
                                padding: "8px 8px 5px 8px",
                                height: "30px",
                              }}
                              value={this.state.onetimeBonusCredits}
                              onChange={this.handleOnetimeBonusCreditsChange.bind(
                                this
                              )}
                              onFocus={(event) => {
                                event.target.select();
                              }}
                            />
                          </>
                        )}
                      </div>
                    </div>
                    <div
                      className="row justify-content-center"
                      style={{ height: "38px" }}
                    >
                      <div className="col-sm-4 d-flex align-self-center">
                        <span className="me-2" style={{ marginTop: "1px" }}>
                          <input
                            type="checkbox"
                            id="recurringBonusCredits-checkbox"
                            value={this.state.isRecurring}
                            onChange={(e) =>
                              this.handleIsRecurringCheckboxChange(e)
                            }
                            checked={this.state.isRecurring}
                          />
                        </span>

                        <label
                          className="form-label"
                          htmlFor="recurringBonusCredits-checkbox"
                          style={{ cursor: "pointer" }}
                        >
                          Recurring
                        </label>
                      </div>
                      <div className="col-sm-3 d-flex ps-0 align-self-center">
                        {this.state.isRecurring && (
                          <>
                            <input
                              type="number"
                              autoComplete="off"
                              id="multiStepsFirstName"
                              name="multiStepsFirstName"
                              className="form-control"
                              style={{
                                padding: "8px 8px 5px 8px",
                                height: "30px",
                              }}
                              value={this.state.recurringBonusCredits}
                              onChange={this.handleRecurringBonusCreditChange.bind(
                                this
                              )}
                              onFocus={(event) => {
                                event.target.select();
                              }}
                            />
                          </>
                        )}
                      </div>
                    </div>
                  </> :
                  <div
                    className="row justify-content-center"
                    style={{ height: "38px" }}
                  >
                    <div className="col-sm-3 d-flex align-self-center">
                      <label
                        className="form-label"
                        htmlFor="ontimeBonusCredits-checkbox"
                        style={{ cursor: "pointer" }}
                      >
                        Onetime
                      </label>
                    </div>
                    <div className="col-sm-4 d-flex ps-0 align-self-center">
                      <>
                        <input
                          type="number"
                          autoComplete="off"
                          id="multiStepsFirstName"
                          name="multiStepsFirstName"
                          className="form-control"
                          style={{
                            padding: "8px 8px 5px 8px",
                            height: "30px",
                          }}
                          value={this.state.onetimeBonusCredits}
                          onChange={this.handleOnetimeBonusCreditsChange.bind(
                            this
                          )}
                          onFocus={(event) => {
                            event.target.select();
                          }}
                        />
                      </>
                    </div>
                  </div>
                }
              </DialogContent>
              <DialogActions
                className="justify-content-center"
                style={{
                  padding: "1.5em",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              >
                <Button
                  variant="contained"
                  size="large"
                  type="submit"
                  style={{
                    background: "#0B6F9D",
                    color: "#fff",
                    marginRight: "1rem",
                    padding: "2px 10px",
                    textTransform: "capitalize",
                  }}
                  startIcon={<SaveIcon />}
                >
                  Apply
                </Button>
                <Button
                  variant="contained"
                  size="large"
                  style={{
                    background: "#717373",
                    color: "#fff",
                    marginRight: "1rem",
                    padding: "2px 10px",
                    textTransform: "capitalize",
                  }}
                  startIcon={<CloseIcon />}
                  onClick={this.handleBonusCreditsClose.bind(this)}
                >
                  Cancel
                </Button>
              </DialogActions>
            </ValidatorForm>
          </Dialog>
        </>
      );
    }
  }
}
export default withRouter(AdminAccountBilling);
